/* sm-home-hero-slider — Swiper 11 (global). Mirrors Manukora HeroSlider: clickable pagination + keyboard. */
(function () {
  function init(el) {
    if (el.dataset.smInit || typeof Swiper === 'undefined') return;
    el.dataset.smInit = '1';
    var opts = {
      keyboard: { enabled: true, onlyInViewport: true, pageUpDown: true },
      loop: el.dataset.loop === 'true',
      watchOverflow: true
    };
    var pag = el.querySelector('.swiper-pagination');
    if (pag) opts.pagination = { el: pag, clickable: true };
    if (el.dataset.autoplay === 'true') opts.autoplay = { delay: parseInt(el.dataset.delay, 10) || 5000, disableOnInteraction: false };
    new Swiper(el, opts);
  }
  function all() { document.querySelectorAll('.sm-home-hero-slider').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  window.addEventListener('load', all);
  document.addEventListener('shopify:section:load', all);
})();
